import React from 'react';
import MathCCAClass32025 from 'views/MathCCAClass32025';

const MathClubPage = () => {
  return <MathCCAClass32025/>;
};

export default MathClubPage;

